import Styled from 'styled-components';

// const InfoWraper = Styled.div`
//     display: flex;
//     justify-content:center;
//     align-items: center;
//     padding: 16px 0;   
//     .fullscreen{ 
//         display: flex;
//         span{
//             svg{
//                 display: block;
//                 line-height: normal;
//                 margin: 0 3px;
//             }
//         }
//     }  
         
//     .nav-author{
//         display: flex;
//         span, a{
//             display: block;
//             line-height: normal;
//             margin: 0 3px;
//             span.ant-avatar-image {
//                 background: #efefef;
//                 border-radius: 5px;
//             }

//         }
//         a {
//             display: flex;
//             align-items: center;
//             gap: 8px;
//             text-decoration: none;
//             color:#fff;
//             font-weight:700;
//         }
//     }
//     .nav-author{
//         a.ant-dropdown-trigger{
//             img{
//                 max-width: 20px;
//             }
//         }
//     }
// `;

const InfoWraper = Styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 24px; 
    @media (max-width: 768px) {
        gap: 12px;
    }

    .average-mtd {
        display: flex;
        align-items: center;
        gap: 10px;
        background: rgba(255, 255, 255, 0.08);
        border: 1px solid rgba(255, 255, 255, 0.15);
        border-radius: 12px;
        padding: 5px 14px 5px 8px;
        color: #fff;
        white-space: nowrap;
        backdrop-filter: blur(8px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;

        &:hover {
            background: rgba(255, 255, 255, 0.14);
            border-color: rgba(255, 255, 255, 0.3);
            transform: translateY(-1px);
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);

            .average-mtd__icon-container svg {
                transform: scale(1.1);
            }
        }

        .average-mtd__icon-container {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 26px;
            height: 26px;
            border-radius: 50%;
            background: rgba(16, 185, 129, 0.15);
            border: 1px solid rgba(16, 185, 129, 0.3);
            
            svg {
                font-size: 14px;
                color: #10B981;
                filter: drop-shadow(0 0 2px rgba(16, 185, 129, 0.4));
                transition: transform 0.3s ease;
            }
        }

        .average-mtd__info {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            line-height: 1.2;

            .average-mtd__label {
                font-size: 9px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.8px;
                opacity: 0.75;
                color: rgba(255, 255, 255, 0.85);
            }

            strong {
                font-size: 14px;
                font-weight: 800;
                color: #ffffff;
                letter-spacing: -0.2px;
            }
        }

        @media (max-width: 768px) {
            padding: 4px 10px 4px 6px;
            gap: 6px;
            
            .average-mtd__icon-container {
                width: 22px;
                height: 22px;
                svg {
                    font-size: 12px;
                }
            }
            
            .average-mtd__info {
                .average-mtd__label {
                    font-size: 8px;
                    letter-spacing: 0.5px;
                }
                strong {
                    font-size: 12px;
                }
            }
        }

        @media (max-width: 576px) {
            padding: 4px 8px;
            .average-mtd__icon-container {
                display: none;
            }
            .average-mtd__info {
                .average-mtd__label {
                    font-size: 8px;
                }
                strong {
                    font-size: 11px;
                }
            }
        }
    }
    
    .language, .fullscreen, .themestyle, .nav-author {
        display: flex;
        align-items: center;
        gap: 8px;
        span {
            display: flex;
            gap: 8px;
            .lang-selector {
                color: #fff;
                font-weight: 600;
                @media (max-width: 768px) {
                    display: none;
                }
            }
        }
    }

    .icon-button {
        font-size: 18px;
        color: #fff;
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    

    .nav-author a {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #fff;
        font-weight: 700;
        text-decoration: none;
        .user-first__name {
            @media (max-width: 576px) {
                display: none;
            }
        }
    }

    .ant-avatar {
        background: #efefef;
        border-radius: 5px;
    }
`;

const SettingDropdwon = Styled.div`
    .setting-dropdwon{
        max-width: 700px;
        padding: 4px 0;
        .setting-dropdwon__single{
            align-items: flex-start;
            padding: 16px 20px;
            margin-bottom: 0;
            position: relative;
            &:after{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                box-shadow: 0 5px 20px ${({ theme }) => theme['gray-solid']}15;
                z-index: 1;
                content: '';
                opacity: 0;
                visibility: hidden;
            }
            &:hover{
                &:after{
                    opacity: 1;
                    visibility: visible;
                }
            }
            h1{
                font-size: 15px;
                font-weight: 500;
                margin: -4px 0 2px;
            }
            p{
                margin-bottom: 0;
                color: ${({ theme }) => theme['gray-solid']};
            }
            img{
                ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 16px;
                transform: ${({ theme }) => (theme.rtl ? 'rotatey(180deg)' : 'rotatey(0deg)')};
            }
            figcaption{
                text-align: ${({ theme }) => (!theme.rtl ? 'left' : 'right')}
            }
        }
    }
`;

const NestedDropdwon = Styled.div`
    .support-dropdwon{
        padding: 10px 15px;
        text-align: ${({ theme }) => (!theme.rtl ? 'left' : 'right')};
        ul{
            &:not(:last-child){
                margin-bottom: 16px;
            }
            h1{
                font-size: 14px;
                font-weight: 400;
                color: ${({ theme }) => theme['light-color']};
            }
            li{
                a{
                    font-weight: 500;
                    padding: 4px 16px;
                    color: ${({ theme }) => theme['dark-color']};
                    &:hover{
                        background: #fff;
                        color: ${({ theme }) => theme['primary-color']};
                    }
                }
            }
        }
    }
`;

const UserDropDwon = Styled.div`
    .user-dropdwon{
        width: 280px;
        .user-dropdwon__info{
            display: flex;
            align-items: flex-start;
            padding: 20px 25px;
            border-radius: 8px;
            margin-bottom: 12px;
            background: ${({ theme }) => theme['bg-color-normal']};
            img{
                ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 15px;
            }
            figcaption{
                h1{
                    font-size: 14px;
                    margin-bottom: 2px;
                    color:  ${({ theme }) => theme['dark-color']};
                }
                p{
                    margin-bottom: 0px;
                    font-size: 13px;
                    color: ${({ theme }) => theme['gray-solid']};
                }
            }
        }
        .user-dropdwon__links{
            a{
                // width: calc(100% + 30px);
                left: -15px;
                right: -15px;
                display: inline-flex;
                align-items: center;
                padding: 10px 12px;
                font-size: 14px;
                transition: .3s;
                color: ${({ theme }) => theme['light-color']};
                &:hover{
                    background: ${({ theme }) => theme['primary-color']}05;
                    color: ${({ theme }) => theme['primary-color']};
                    ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 22px;
                }
                svg{
                    width: 16px;
                    transform: ${({ theme }) => (theme.rtl ? 'rotateY(180deg)' : 'rotateY(0deg)')};
                    ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 14px;
                }
            }
        }
        .user-dropdwon__bottomAction{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            font-weight: 500;
            text-align: center;
            position: relative;
            width: calc(100% + 30px);
            left: -15px;
            right: -15px;
            height: calc(100% + 15px);
            bottom: -15px;
            border-radius: 0 0 6px 6px;
            padding: 15px 0;
            background: ${({ theme }) => theme['bg-color-light']};
            color: ${({ theme }) => theme['light-light']};
            svg{
                width: 15px;
                height: 15px;
                ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
            }
        }
    }
`;

const AtbdTopDropdwon = Styled.div`
    .atbd-top-dropdwon__title .title-text {        
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 10px;
    }
    .atbd-top-dropdwon__content figcaption .atbd-top-dropdwonText {
        min-width: 216px;
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 15px;
    }
    .atbd-top-dropdwon__content .notification-icon {
        width: 39.2px;
        height: 32px;
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 15px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .atbd-top-dropdwon__content .notification-icon.bg-primary {
        background: #39318615;
        color: #393186;
    }
    .atbd-top-dropdwon__content .notification-icon.bg-secondary {
        background: #FF69A515;
        color: #FF69A5;
    }
    .atbd-top-dropdwon__content .notification-icon svg {
        width: 18px;
        height: 18px;
    }
    .atbd-top-dropdwon__content .notification-content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }  

    .atbd-top-dropdwon__content figcaption span {
        ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 0;
    }

    .notification-text h1 {
        font-size: 14px;
        font-weight: 400;
        color: #5A5F7D;
        margin-bottom: 4px;
    }

    .notification-text h1 span {
        color: #393186;
        font-weight: 500;
        ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 0;
    }

    .notification-text p {
        font-size: 12px;
        color: #ADB4D2;
        margin-bottom: 0;
        text-align: ${({ theme }) => (!theme.rtl ? 'left' : 'right')}
    }
`;

const AtbdTopDropdwon1 = Styled.div`
    width:240px !important;
    display:flex;
    .atbd-top-dropdwon__nav {
        li {
            a {  
                padding: 10px 12px !important; 
                figure {
                    display:flex;
                    margin-bottom: 0;
                    figcaption {
                        display:flex;
                        h1 {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            font-size: 14px;
                            font-weight: 500;
                            margin-bottom: 0px;
                        }
                    }
                }
            }
            &:hover{
                background: #e5f2fd;
            }
            // .active{
            //     background: #e5f2fd;
            // }
            width: 100%;
        }
        &:last-child {
            margin: 0; 
        }
        
    }
       
    .atbd-top-dropdwon__content { align-items : center !important; }
    .atbd-top-dropdwon__content img { max-width: 30px!important; }
           
    .atbd-top-dropdwon__title .title-text {        
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 10px;
    }
    .atbd-top-dropdwon__content figcaption .atbd-top-dropdwonText {
        min-width: 140px;
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 15px;
    }
    

    .atbd-top-dropdwon__content figcaption span {
        ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 0;
    }

    .atbd-top-dropdwon__content figcaption {  margin: 3px 7px; align-items: center; }

    .atbd-top-dropdwon__content  span svg{ color: #393186;  font-weight: 500; }

    
`;

const NavAuth = Styled.span`
    i, svg, img {
        ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
        width:40px;
    }
`;

export { InfoWraper, SettingDropdwon, NestedDropdwon, UserDropDwon, AtbdTopDropdwon, AtbdTopDropdwon1, NavAuth };
